"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripHtmlFromText = exports.removeEditorStyles = exports.mapRecipientsFilterToPayload = exports.isNumber = exports.getTitleFromSubject = exports.getTitleForCopy = exports.getTemplateWithContent = exports.getScheduleLocal = exports.getSanitizedText = exports.getPreviewTextHTML = exports.getPreviewText = exports.getContent = exports.formatDateFilterFromStorage = exports.formatDateFilterForStorage = exports.formatDate = exports.checkMaliciousPayloads = exports.addEditorStyles = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _post_content = _interopRequireDefault(require("!!css-loader!sass-loader!../../../../sass/src/modules/_post_content.scss"));

var _VariableParser = _interopRequireDefault(require("./VariableParser"));

var _dateFormatting = require("@insided/shared/utils/dateFormatting");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getPreviewTextHTML = function getPreviewTextHTML() {
  var previewText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return previewText ? "<div class=\"email-campaigns-preview-text\" style=\"font-size:0px;line-height:1px;mso-line-height-rule:exactly;display:none;max-width:0px;max-height:0px;opacity:0;overflow:hidden;mso-hide:all;\">".concat(previewText, "</div>") : '';
};

exports.getPreviewTextHTML = getPreviewTextHTML;

var addEditorStyles = function addEditorStyles(content) {
  var styles = "<style>".concat(_post_content.default, "</style>");
  var postContent = "<div class=\"post__content post__content--new-editor post__content--email\">".concat(content, "</div>");
  return "".concat(styles).concat(postContent);
};

exports.addEditorStyles = addEditorStyles;

var getPreviewText = function getPreviewText(content) {
  if (!content) return '';
  var tmp = document.createElement('div');
  tmp.innerHTML = content;
  var previewText = tmp.querySelector('.email-campaigns-preview-text');
  return previewText ? previewText.innerHTML : '';
};

exports.getPreviewText = getPreviewText;

var removeEditorStyles = function removeEditorStyles(content) {
  var tmp = document.createElement('span');
  tmp.innerHTML = content;
  var postContentDiv = tmp.querySelector('.post__content--email');
  return postContentDiv ? postContentDiv.innerHTML : content;
};

exports.removeEditorStyles = removeEditorStyles;

var getContent = function getContent(content, status) {
  if (!content) {
    return '<p>Hi,</p>';
  }

  var updatedContent = new _VariableParser.default(content).toInputVariable(false).result();

  if ((status === null || status === void 0 ? void 0 : status.toLocaleLowerCase()) === 'draft' || !status) {
    return removeEditorStyles(updatedContent);
  }

  return updatedContent;
};

exports.getContent = getContent;

var getTemplateWithContent = function getTemplateWithContent(content, template, status) {
  if (!!template && ((status === null || status === void 0 ? void 0 : status.toLocaleLowerCase()) === 'draft' || !status)) {
    return template.replace('{content}', content);
  }

  return content;
};

exports.getTemplateWithContent = getTemplateWithContent;

var isNumber = function isNumber(value) {
  return !isNaN(Number(value));
};

exports.isNumber = isNumber;

var getTitleForCopy = function getTitleForCopy(title) {
  var copiedTitle = '';

  if (title.length >= 56) {
    copiedTitle = title.substring(0, 56) + ' - Copy';
  } else {
    copiedTitle = title + ' - Copy';
  }

  return copiedTitle;
};

exports.getTitleForCopy = getTitleForCopy;

var getTitleFromSubject = function getTitleFromSubject(subject) {
  var title = subject;

  if (subject.length >= 64) {
    title = subject.substring(0, 60) + '...';
  }

  return title;
};

exports.getTitleFromSubject = getTitleFromSubject;

var stripHtmlFromText = function stripHtmlFromText(subject) {
  return subject.replace(/(<\/?(?:input-variable)[^>]*>)|<[^>]+>/gi, '$1');
};

exports.stripHtmlFromText = stripHtmlFromText;
var maliciousPayloadsHTMLTags = ['script', 'img', 'body', 'iframe', 'input', 'link', 'table', 'td', 'div', 'object'];
var maliciousPayloadsHTMLAttributes = ['src=', 'onerror=', 'onload=', 'background=', 'dynsrc=', 'lowsrc=', 'rel=', 'href=', 'style=', 'data=', 'type='];
var maliciousPayloadsJavascript = ['alert(', 'javascript:', 'url(', 'expression('];
var maliciousPayloadsOperands = ['&lt;', '&gt;', '<', '>', '</', '/>', '='];

var checkMaliciousPayloads = function checkMaliciousPayloads(str) {
  var isMaliciousHTMLTags = maliciousPayloadsHTMLTags.some(function (payload) {
    return str.toLowerCase().includes("<".concat(payload)) || str.toLowerCase().includes("&lt;".concat(payload));
  });
  var isMaliciousHTMLAttributes = maliciousPayloadsHTMLAttributes.some(function (payload) {
    return str.toLowerCase().includes(payload);
  });
  var isMaliciousJavascript = maliciousPayloadsJavascript.some(function (payload) {
    return str.toLowerCase().includes(payload);
  });
  var isMaliciousOperands = maliciousPayloadsOperands.some(function (payload) {
    return str.toLowerCase().includes(payload);
  });
  return isMaliciousHTMLTags && isMaliciousHTMLAttributes && isMaliciousJavascript && isMaliciousOperands;
};

exports.checkMaliciousPayloads = checkMaliciousPayloads;

var getSanitizedText = function getSanitizedText(subject) {
  return new _VariableParser.default(subject).toBracketVariable().removeBreakTags().replaceBlankSpaces().result();
};

exports.getSanitizedText = getSanitizedText;

var getScheduleLocal = function getScheduleLocal(schedule) {
  var scheduleLocal = _objectSpread({}, schedule);

  var scheduleDate = new Date("".concat(scheduleLocal.date, " ").concat(scheduleLocal.time, " GMT").concat(scheduleLocal.timeZone.offset));
  var scheduleDateLocal = new Date(scheduleDate.toLocaleString('en-US', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }));
  return (0, _dateFormatting.formatScheduleDate)(scheduleDateLocal);
};

exports.getScheduleLocal = getScheduleLocal;

var formatDate = function formatDate(date) {
  return new Date(date).toISOString().slice(0, 19);
};

exports.formatDate = formatDate;

var formatDateFilterFromStorage = function formatDateFilterFromStorage(dateFilter) {
  if (!dateFilter) {
    return null;
  }

  var operatorToConditionMap = {
    DAYS_AFTER: 'lt',
    DAYS_BEFORE: 'gt',
    AFTER: 'from',
    BEFORE: 'to',
    ON: 'eq',
    BETWEEN: 'range'
  };

  var operator = dateFilter.operator,
      _dateFilter$values = (0, _slicedToArray2.default)(dateFilter.values, 2),
      firstValue = _dateFilter$values[0],
      secondValue = _dateFilter$values[1];

  if (!Object.keys(operatorToConditionMap).includes(operator)) {
    return null;
  }

  var condition = operatorToConditionMap[operator];
  var type;
  var data;

  if (['DAYS_BEFORE', 'DAYS_AFTER'].includes(operator)) {
    data = parseInt(firstValue);
    type = 'relative';
  } else if (['ON', 'BEFORE', 'AFTER'].includes(operator)) {
    type = 'absolute';
    data = new Date(firstValue).toISOString();
  } else {
    type = 'range';
    data = {
      from: new Date(firstValue).toISOString(),
      to: new Date(secondValue).toISOString()
    };
  }

  return {
    condition: condition,
    data: data,
    type: type,
    unit: 'day'
  };
};

exports.formatDateFilterFromStorage = formatDateFilterFromStorage;

var formatDateFilterForStorage = function formatDateFilterForStorage(dateFilter) {
  if (!dateFilter) {
    return null;
  }

  var conditionToOperatorMap = {
    lt: 'DAYS_AFTER',
    gt: 'DAYS_BEFORE',
    from: 'AFTER',
    to: 'BEFORE',
    eq: 'ON',
    range: 'BETWEEN'
  };
  var condition = dateFilter.condition,
      data = dateFilter.data;

  if (!Object.keys(conditionToOperatorMap).includes(condition)) {
    return null;
  }

  var operator = conditionToOperatorMap[condition];
  var values;

  if (['DAYS_BEFORE', 'DAYS_AFTER'].includes(operator)) {
    values = [data];
  } else if (['ON', 'BEFORE', 'AFTER'].includes(operator)) {
    values = [formatDate(data)];
  } else {
    var from = data.from,
        to = data.to;
    values = [formatDate(from), formatDate(to)];
  }

  return {
    operator: operator,
    values: values
  };
};

exports.formatDateFilterForStorage = formatDateFilterForStorage;

var mapRecipientsFilterToPayload = function mapRecipientsFilterToPayload(recipientsFilters, rolesMap, allGroups) {
  var _recipientsFilters$cu, _recipientsFilters$cu2, _recipientsFilters$ma, _recipientsFilters$ma2, _recipientsFilters$gr, _recipientsFilters$gr2;

  // TODO: This is a temporary fix as part of a API refactor, when this is done we should only send the ids
  var customRoles = (_recipientsFilters$cu = recipientsFilters === null || recipientsFilters === void 0 ? void 0 : (_recipientsFilters$cu2 = recipientsFilters.customRoles) === null || _recipientsFilters$cu2 === void 0 ? void 0 : _recipientsFilters$cu2.reduce(function (acc, roleName) {
    var role = rolesMap === null || rolesMap === void 0 ? void 0 : rolesMap.customRoles.find(function (role) {
      return role.value === roleName;
    });

    if (role) {
      return [].concat((0, _toConsumableArray2.default)(acc), [role.value, "".concat(role.id)]);
    }

    return acc;
  }, [])) !== null && _recipientsFilters$cu !== void 0 ? _recipientsFilters$cu : null; // TODO: This is a temporary fix as part of a API refactor, when this is done we should only send the ids

  var mainRoles = (_recipientsFilters$ma = recipientsFilters === null || recipientsFilters === void 0 ? void 0 : (_recipientsFilters$ma2 = recipientsFilters.mainRoles) === null || _recipientsFilters$ma2 === void 0 ? void 0 : _recipientsFilters$ma2.reduce(function (acc, roleName) {
    var role = rolesMap === null || rolesMap === void 0 ? void 0 : rolesMap.mainRoles.find(function (role) {
      return role.value === roleName;
    });

    if (role) {
      return [].concat((0, _toConsumableArray2.default)(acc), [role.value, "".concat(role.id)]);
    }

    return acc;
  }, [])) !== null && _recipientsFilters$ma !== void 0 ? _recipientsFilters$ma : null;
  var groups = (_recipientsFilters$gr = recipientsFilters === null || recipientsFilters === void 0 ? void 0 : (_recipientsFilters$gr2 = recipientsFilters.groups) === null || _recipientsFilters$gr2 === void 0 ? void 0 : _recipientsFilters$gr2.reduce(function (acc, groupId) {
    var userGroup = allGroups.find(function (group) {
      return String(group.id) === groupId;
    });

    if (userGroup) {
      return [].concat((0, _toConsumableArray2.default)(acc), [userGroup.id]);
    }

    return acc;
  }, [])) !== null && _recipientsFilters$gr !== void 0 ? _recipientsFilters$gr : null;
  var joinDate = formatDateFilterForStorage(recipientsFilters === null || recipientsFilters === void 0 ? void 0 : recipientsFilters.joinDate);
  var lastActivityDate = formatDateFilterForStorage(recipientsFilters === null || recipientsFilters === void 0 ? void 0 : recipientsFilters.lastActivity);
  return {
    customRoles: customRoles,
    mainRoles: mainRoles,
    groups: groups,
    joinDate: joinDate,
    lastActivityDate: lastActivityDate
  };
};

exports.mapRecipientsFilterToPayload = mapRecipientsFilterToPayload;